
import _Vue from 'vue';
import { TranslateResult } from "vue-i18n";
import {  validate } from 'rut.js'

declare module 'vue/types/vue' {
  interface Vue {
    $v: Record<string, ReturnType<(text: TranslateResult) => (value: any) => string | boolean>>;
  }
}

export default function Validations(Vue: typeof _Vue): void {
  Vue.prototype.$v = {
    required: (text: TranslateResult) => (value: any) =>  value != null && value !== '' && value.length !== 0 || text,
    email: (text: TranslateResult) => (value: string) => {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return !value || value === '' || pattern.test(value.trim()) || text;
    },
    phone: (text: TranslateResult) => (value: string) => {
      const pattern = /^[+]*[\s/0-9]{8,}$/;
      return !value || value === '' || pattern.test(value) || text;
    },
    rut: (text: TranslateResult) => (value: string) => {
      return !value || value === '' || validate(value) || text;
    },
    scoreValidNumber: (text: TranslateResult) => (value: string) => {
      return !value || value === '' || (parseInt(value) <= 9 && parseInt(value) >= 0) || text;
    },
  }
}
